module.exports = __webpack_public_path__ + "img/1182787916.95e7a28a.jpg";